import { useEffect, useState } from "react";

/**
 * Returns the CustomerDashboard "Revenue Intelligence" tab-row action slot, so
 * an embedded tab can portal its toolbar actions (e.g. Refresh) up next to the
 * tabs instead of rendering its own toolbar row below the divider.
 */
export default function useSubnavSlot() {
  const [slot, setSlot] = useState(null);
  useEffect(() => {
    setSlot(document.getElementById("ri-subnav-actions"));
  }, []);
  return slot;
}
